import React from 'react';
import { motion } from 'framer-motion';
import styles from './Media.module.css';

import abpBengala from "./abp_ananda.png"
import ahmedabadMirror from "./ahmedabadeMirror.png"
import dailyhunt from "./Dailyhunt.png"
import hindustanMetro from "./hindustan_metro.png"
import hindustan from "./hindustan-bytes.png"
import newsNation from "./newsNation.webp"


function Media() {
    const mediaData = [
        {
            logo: newsNation,
            name: "News Nation",
            link: "https://english.newsnationtv.com/brand-stories/brand-stories-english/supriyo-chatterjee-the-man-behind-affiliate-ritual-and-his-inspiring-journey-of-self-resilience-and-tenacity-6943939"
        },
        {
            logo: abpBengala,
            name: "ABP Ananda",
            link: "https://bengali.abplive.com/brand-wire/revolution-in-affiliate-marketing-affiliate-ritual-2-point-0-launched-1091006"
        },
    ];

    const mediaData2 = [
        {
            logo: hindustan,
            name: "Hindustan Bytes",
            link: "https://www.hindustanbytes.com/affiliate-ritual-leading-ed-tech-platform-empowering-educated-youths-to-become-financially-independent"
        },
        {
            logo: ahmedabadMirror,
            name: "Ahmedabad Mirror",
            link: "https://www.ahmedabadmirror.com/affiliate-ritual-20-by-supriyo-chatterjee-a-revolutionary-move-towards-online-success/81874460.html"
        },
        {
            logo: dailyhunt,
            name: "Dailyhunt",
            link: "https://m.dailyhunt.in/news/india/english/republic+news+india-epaper-dhfacc36dfce9c4bb68db0e89d033c921b/affiliate+ritual+leading+edtech+platform+empowering+educated+youths+to+become+financially+independent-newsid-dhfacc36dfce9c4bb68db0e89d033c921b_5794bad0854411efbfc5cb9e96709a27?sm=Y"
        },
        {
            logo: hindustanMetro,
            name: "Hindustan Metro",
            link: "https://hindustanmetro.com/navigating-the-new-wave-of-online-earning-with-affiliate-ritual/"
        },

    ]

    return (
        <div className={styles.mediaContainer}>
            <p className={styles.mediaParagraph}>Let's meet with the team of our industry expert medias. We believe that you will be able to change your life with the most advanced AI integrated training module cooked by Affiliate Ritual.</p>

            <div className={styles.mediaParentWrapper}>
                <div className={styles.mediaItems} >
                    {mediaData.map((item, i) => (
                        <motion.div
                            onClick={() => {
                                window.open(item.link, "_blank"); // Open the link in a new tab
                            }}
                            key={i}
                            className={styles.mediaItemWrapper}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, ease: "easeOut", delay: i * 0.1 }}
                            whileHover={{ scale: 1.05, boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)" }}
                        >
                            <img
                                className={styles.mediaImg}
                                src={item.logo}
                                alt={item.name || 'Media Logo'}
                            />
                        </motion.div>
                    ))}

                </div>

                <div className={styles.mediaItems2} >
                    {mediaData2.map((item, i) => (
                        <motion.div
                            onClick={() => {
                                window.open(item.link, "_blank"); // Open the link in a new tab
                            }}
                            key={i}
                            className={styles.mediaItemWrapper2}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, ease: "easeOut", delay: i * 0.1 }}
                            whileHover={{ scale: 1.05, boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)" }}
                        >
                            <img
                                className={styles.mediaImg2}
                                src={item.logo}
                                alt={item.name || 'Media Logo'}

                            />

                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Media;
